import { useContext } from 'react';
import useHttp from './useHttp';
import AuthContext from '../context/authContext';

// API access for managing individual (single-use) discount codes of a parent discount code
const useIndividualDiscountCode = () => {
  const authCtx = useContext(AuthContext);
  const { isLoading, error, sendRequest } = useHttp();

  const getDiscountCodes = async () => {
    return sendRequest(
      {
        url: '/api/v1/discountCode',
        method: 'GET',
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Laden der Rabattcodes'
    );
  };

  const getIndividualCodes = async (discountCodeId, params = {}) => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/codes`,
        method: 'GET',
        params,
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Laden der individuellen Codes'
    );
  };

  const generateIndividualCodes = async (discountCodeId, payload) => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/generate`,
        method: 'POST',
        body: payload,
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Generieren der individuellen Codes'
    );
  };

  const revokeIndividualCodes = async (discountCodeId, payload) => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/codes/revoke`,
        method: 'POST',
        body: payload,
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Widerrufen der individuellen Codes'
    );
  };

  const reactivateIndividualCodes = async (discountCodeId, codeIds) => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/codes/reactivate`,
        method: 'POST',
        body: { codeIds },
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Reaktivieren der individuellen Codes'
    );
  };

  const downloadIndividualCodesCsv = async (discountCodeId, params = {}) => {
    return sendRequest(
      {
        url: `/api/v1/discountCode/${discountCodeId}/codes/csv`,
        method: 'GET',
        params,
        returnBlob: true,
        headers: authCtx.getAuthHeaders(),
      },
      'Fehler beim Exportieren der individuellen Codes'
    );
  };

  return {
    isLoading,
    error,
    getDiscountCodes,
    getIndividualCodes,
    generateIndividualCodes,
    revokeIndividualCodes,
    reactivateIndividualCodes,
    downloadIndividualCodesCsv,
  };
};

export default useIndividualDiscountCode;
